import React from 'react';
import { Autocomplete, TextField, Box, Typography, alpha } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface DosenAutocompleteProps {
  label?: string;
  sx?: any;
  options: any[];
  [key: string]: any; // todas as outras props do MUI
}

export default function DosenAutocomplete({
  label = '',
  sx = {},
  options = [],
  ...props
}: DosenAutocompleteProps) {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        ...sx
      }}
    >
      {/* LABEL */}
      {label && (
        <Typography
          sx={{
            color: 'var(--Text-text-primary, #FDFDFD)',
            fontSize: 14,
            fontFamily: 'Inter',
            fontWeight: 500,
            lineHeight: '20px'
          }}
        >
          {label}
        </Typography>
      )}

      <Autocomplete
        options={options}
        popupIcon={
          <KeyboardArrowDownIcon
            sx={{
              color: 'var(--Stroke-icon-dim, #868686)',
              fontSize: 18
            }}
          />
        }
        componentsProps={{
          paper: {
            sx: {
              background: 'var(--Fill-Transparent-trans-normal-7, rgba(0,0,0,0.70)) !important',
              backdropFilter: 'blur(20px)',
              borderRadius: '6px',
              border: '1px solid var(--Stroke-Form-Input-border-light, #868686)',
              color: 'var(--Text-text-primary, #FDFDFD)',
              mt: 1,
              '> ul': {
                padding: 0
              },
              '> ul > li': {
                fontFamily: 'Inter',
                fontSize: 14,
                padding: '10px 12px',
                borderBottom: '1px solid rgba(255,255,255,0.05)',
                '&:hover': {
                  background: alpha('#F79420', 0.15)
                }
              }
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Please Select"
            variant="outlined"
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                background: 'var(--Fill-Transparent-trans-normal-7, rgba(0, 0, 0, 0.70))',
                borderRadius: '6px',
                outline: '1px solid var(--Stroke-Form-Input-border-light, #868686)',
                outlineOffset: '-1px',
                height: '40px',
                padding: 0,
                pl: '12px',
                pr: '8px',
                color: 'var(--Text-text-primary, #FDFDFD)',
                fontFamily: 'Inter',
                fontWeight: 400,
                fontSize: 14,
                '& .MuiAutocomplete-input': {
                  color: 'var(--Text-text-primary, #FDFDFD)'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none'
                },
                '&:hover': {
                  outline: '1px solid #FDFDFD'
                },
                '&.Mui-focused': {
                  outline: '1px solid #F79420'
                }
              },
              '& .MuiInputBase-input': {
                background: 'transparent'
              }
            }}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              sx: {
                gap: '4px',
                '& .MuiAutocomplete-input': {
                  color: 'inherit'
                }
              }
            }}
          />
        )}
        {...props}
      />
    </Box>
  );
}
